const pluginName = 'questionsPlugin';
const defaults = {
  registrationPlugin: null,
  i18n: null,
  eventCountry: '',
  registrantIndex: 1,
  registrantsPersonalInformation: null,
  callbacks: {
    getSelectedCountry: () => {},
    getProvidedFor: () => {},
  },
};
const classes = {
  hidden: 'hidden',
  hasError: 'has-error',
  clearFix: 'clearfix',
};
const selectors = {
  questionGroup: '[data-js-question-group]',
  question: '[data-js-question]',
  optInQuestion: '[data-question-type="marketing-opt-in"],[data-question-type="sms-opt-in"]',
  geographicallyLimitedQuestion: '[data-allowed-countries]',
  optOutAnswer: '[data-opt-in-answer="0"]',
  addCustomOptionButton: '[data-js-add-custom-option]',
  removeCustomOptionButton: '[data-js-remove-option]',
  customOptionInput: '[data-js-custom-option]',
};

const getElements = ($element) => ({
  $element,
  $snackBar: $('[data-js-snack-bar]'),
});

/**
 * get the selected option id of $parent
 *
 * @param data
 * @param $parent
 * @returns {*}
 * @private
 */
const getSelectedQuestionOptions = (data, $parent) => {
  // select
  if ($parent.is('select')) {
    return [$parent.children('option:selected').data('option-id')];
  }

  // When the $parent is a radio/checkbox it's a single input within the question, rather than the entire question
  // We need to collect all of the checked options within the question container for determining the display
  // of child questions
  const $questionContainer = data.elements.$element.find(`.question-container-${$parent.data('question-id')}`);
  const $children = $questionContainer.find('input').filter(':checked');

  return $children.get().map((child) => $(child).data('option-id'));
};

/**
 * Show the given question, dealing with preselection
 * @param data
 * @param $questionContainer
 */
const showQuestion = (data, $questionContainer) => {
  const renderingType = $questionContainer.attr('data-rendering-type');

  $questionContainer.removeClass(classes.hidden);
  $questionContainer.find(':input').prop('disabled', false);

  switch (renderingType) {
    case 'select': {
      const $select = $questionContainer.find('select');
      const $preselectedOption = $select.find('[data-preselected]');

      if ($preselectedOption.length) {
        $select
          .val($preselectedOption.val())
          .trigger('change');
      }

      break;
    }
    case 'radio':
    case 'checkbox': {
      $questionContainer
        .find('[data-preselected]')
        .prop('checked', true)
        .trigger('change');

      break;
    }
    default:
      // nothing
  }
};

/**
 * Hide the given question, and any descending questions recursively
 * @param data
 * @param $questionContainer
 */
const hideConditionalQuestion = (data, $questionContainer) => {
  const $containerFields = $questionContainer.find(':input');

  $questionContainer.addClass(classes.hidden);

  $containerFields.prop('disabled', true);

  // if the hidden conditional question contains any parent questions, go through each one and
  // also hide the children of those conditional questions recursively
  $questionContainer.find('.js-parent-question').each((index, parent) => {
    const $parent = $(parent);
    const questionId = $parent.data('question-id');
    const $children = data.elements.$element.find(`.child-${questionId}`);

    if ($parent.is('select')) {
      $parent.val('');
    } else {
      $parent.prop('checked', false);
    }

    $children.each((childIndex, child) => {
      hideConditionalQuestion(data, $(child).closest('.js-question-container'));
    });
  });
};

/**
 * Toggle conditional questions
 *
 * @param data
 * @param $parent
 */
const conditionalQuestionsToggle = (data, $parent) => {
  const questionId = $parent.data('question-id');
  const selectedOptionIds = getSelectedQuestionOptions(data, $parent);
  const $children = data.elements.$element.find(`.child-${questionId}`);

  $children.each((index, child) => {
    const $child = $(child);
    const $questionContainer = data.elements.$element.find(`.question-container-${$child.data('question-id')}`);

    if (selectedOptionIds.indexOf($child.data('parent-option-id')) > -1) {
      showQuestion(data, $questionContainer);
    } else {
      hideConditionalQuestion(data, $questionContainer);
    }
  });
};

/**
 * Toggle other input
 *
 * @param $parent
 * @param $otherInput
 * @private
 */
const showOtherInput = (event) => {
  const $button = $(event.currentTarget);
  const $parentQuestion = $button.parent('.form-group').find('input, select');
  const name = $parentQuestion.attr('name');
  const $otherInput = $(`#${$button.data('other-input-id')}`);
  const $otherInputFormGroup = $otherInput.parents('.form-group');

  $button.addClass(classes.hidden);

  if ($parentQuestion.attr('type') !== 'checkbox') {
    $parentQuestion.val('').prop('disabled', true);
  }

  $otherInput.attr('name', name);
  $otherInputFormGroup.removeClass(classes.hidden);
};

const removeOtherInput = (event) => {
  const $button = $(event.currentTarget);
  const $parentQuestionContainer = $button.parents('.form-group').prev('.form-group');
  const $parentQuestion = $parentQuestionContainer.find('input, select');
  const $otherInput = $button.parents('.form-group').find('input');
  const $otherInputFormGroup = $button.parents('.form-group');
  const $parentAddOptionButton = $parentQuestionContainer.find(selectors.addCustomOptionButton);

  $otherInputFormGroup.addClass(classes.hidden);
  $parentAddOptionButton.removeClass(classes.hidden);

  $parentQuestion.prop('disabled', false);
  $otherInput.attr('name', '');
  $otherInputFormGroup.addClass(classes.hidden);
};

const checkMatchingOptions = (event) => {
  const $this = $(event.currentTarget);
  const $customInputFormGroup = $this.parents('.form-group');
  const $customInputFeedback = $customInputFormGroup.find('[data-js-feedback]');
  const $parentQuestionContainer = $customInputFormGroup.prev('.form-group');
  const $parentOptions = $parentQuestionContainer.find('[data-js-parent-option]');
  const inputValue = $this.val();
  const parentOptionValues = $parentOptions
    .get()
    .map((parentOption) => $(parentOption).data('js-parent-option').toString());

  if (parentOptionValues.includes(inputValue)) {
    $customInputFormGroup.addClass(classes.hasError);
    $customInputFeedback.removeClass(classes.hidden);
  } else {
    $customInputFormGroup.removeClass(classes.hasError);
    $customInputFeedback.addClass(classes.hidden);
  }
};

/**
 * There is no 'on valid' event, so listen on any change to an input with a pattern, and if it's valid, remove
 * any error stuff we put in there
 * @private
 */
const checkValidPattern = function checkValidPattern() {
  const $field = $(this);
  const $parent = $field.closest('.form-group');
  const $helpBlock = $parent.find('.help-block');

  if ($field.is(':valid')) {
    $helpBlock.remove();
    $field.removeAttr('aria-describedby');
    // there's some silly float css causing the help block to look awful without the clearfix
    $parent.removeClass([classes.hasError, classes.clearFix]);
  }
};

/**
 * Compare function used to sort select options alphabetically
 *
 * @param a
 * @param b
 * @returns {number}
 * @private
 */
const sortSelectOptions = (a, b) => a.text.trim().toLowerCase().localeCompare(b.text.trim().toLowerCase());

/**
 * Compare function used to sort checkbox and radio options alphabetically
 *
 * @param a
 * @param b
 * @returns {number}
 * @private
 */
const sortContainerOptions = (a, b) => {
  const aText = $(a).find(':input').next('span').text()
    .trim()
    .toLowerCase();
  const bText = $(b).find(':input').next('span').text()
    .trim()
    .toLowerCase();

  return aText.localeCompare(bText);
};

/**
 * Alphabetize the multiple choice questions that have that option configured
 * @param index
 * @param questionContainer
 */
const alphabetizeOptions = (index, questionContainer) => {
  const $questionContainer = $(questionContainer);
  const $question = $questionContainer
    .find(':input')
    .not('button');

  if ($question.is('select')) {
    // Sort the select options – excluding the disabled "Select..."
    const elementOptions = $question.children('option:gt(0)');
    const selectedValue = $question.val();
    elementOptions.sort(sortSelectOptions);
    $question.append(elementOptions);
    $question.val(selectedValue);
  }

  if ($question.attr('type') === 'radio') {
    // Sort the radio options which are in .radio blocks
    const $radioQuestionContainers = $question.closest('.js-radio');
    $radioQuestionContainers.sort(sortContainerOptions);
    $questionContainer.find('fieldset').append($radioQuestionContainers);
  }

  if ($question.attr('type') === 'checkbox') {
    // Sort the checkbox options which are in .checkbox blocks
    const $checkboxQuestionContainers = $question.closest('.js-checkbox');
    $checkboxQuestionContainers.sort(sortContainerOptions);
    $questionContainer.find('fieldset').append($checkboxQuestionContainers);
  }
};

/**
 * Enable select2 plugin on select questions with more than 10 options to enable type-to-search
 */
const initializeSelect2 = (index, element) => {
  const $element = $(element);

  if ($element.hasClass('select2-hidden-accessible')) {
    return;
  }

  // "Select..." is an option so we want to only run when there are 11 or more options
  if ($element.children('option').length <= 10) {
    return;
  }

  $element.addClass('event-register__select-manage-question').select2();
};

/**
 * Get all the questions within a container that don't have the hidden class applied
 * @param $container
 * @returns {*}
 */
const getVisibleQuestionsInContainer = ($container) => $container
  .find(selectors.question)
  .not(`.${classes.hidden}`);

/**
 * If there are no questions visible in the plugin at all, hide the entire plugin container
 * @param data
 */
const hidePluginIfNoQuestionsVisible = (data) => {
  data.elements.$element.toggleClass(
    classes.hidden,
    getVisibleQuestionsInContainer(data.elements.$element).length === 0,
  );
};

/**
 * If there are no questions visible in the given group, hide the group
 * @param $group
 */
const hideGroupIfNoQuestionsVisible = ($group) => {
  $group.toggleClass(
    classes.hidden,
    getVisibleQuestionsInContainer($group).length === 0,
  );
};

const toggleGeographicallyLimitedQuestions = (data, readyToCheckCountry, country) => {
  const $geographicallyLimitedQuestions = data.elements.$element.find(selectors.geographicallyLimitedQuestion);

  if (!readyToCheckCountry) {
    $geographicallyLimitedQuestions
      .each((index, element) => {
        $(element)
          .addClass(classes.hidden)
          .find(':checked')
          .prop('checked', false)
          .trigger('change');
      });
  } else {
    $geographicallyLimitedQuestions.each((index, element) => {
      const $question = $(element);
      const allowedCountries = JSON.parse($question.attr('data-allowed-countries'));

      if (allowedCountries.includes(country)) {
        showQuestion(data, $question);
        return;
      }

      $question.addClass(classes.hidden);

      const renderingType = $question.attr('data-rendering-type');

      if (['checkbox', 'radio'].includes(renderingType)) {
        $question
          .find(':checked')
          .prop('checked', false)
          .trigger('change');
      } else {
        $question
          .find(':input')
          .val('')
          .trigger('change');
      }
    });
  }

  setTimeout(() => {
    hideGroupIfNoQuestionsVisible($geographicallyLimitedQuestions.closest(selectors.questionGroup));
    hidePluginIfNoQuestionsVisible(data);
  });
};

/**
 * Method to hide or show the opt-in questions
 * @param data
 * @param show
 */
const toggleOptInQuestions = (data, show) => {
  const $optInQuestion = data.elements.$element.find(selectors.optInQuestion);

  if (!show) {
    $optInQuestion.each((index, element) => {
      $(element)
        .find(selectors.optOutAnswer)
        .prop('checked', true)
        .trigger('change');
    });
  }

  $optInQuestion.toggleClass(classes.hidden, !show);

  setTimeout(() => {
    hideGroupIfNoQuestionsVisible($optInQuestion.closest(selectors.questionGroup));
    hidePluginIfNoQuestionsVisible(data);
  });
};

const setupFileUploaders = (data) => {
  data.elements.$element
    .find('[data-js-upload-question]')
    .fileUploader({
      deleteRequiresConfirmation: true,
      callbacks: {
        confirmDelete: ($fileUploader, fileUploaderData, confirmed) => {
          $.fn.confirmDialog({
            triggerElement: fileUploaderData.elements.$delete,
            bodyContent: data.settings.i18n.confirmDeleteText,
            confirmButtonContent: data.settings.i18n.confirmDeleteButtonText,
            confirmButtonClassName: 'btn btn-danger',
            closeOnConfirm: false,
            bs3: true,
            callbacks: {
              initialized: ($confirmDialog, confirmDialogData) => {
                confirmDialogData.elements.$confirmButton.preventDoubleSubmission();
              },
              confirmed: ($confirmDialog) => {
                window.cdbS3Files.deleteFile({
                  route: $fileUploader.attr('data-delete-route'),
                  data: {
                    fileUploadUuid: $fileUploader.next().val(),
                  },
                })
                  .then(() => {
                    confirmed();
                  })
                  .catch(() => {
                    data.elements.$snackBar.snackBar('add', {
                      type: 'danger',
                      icon: 'exclamation-circle',
                      content: data.settings.i18n.deleteFileError,
                    });
                  })
                  .finally(() => {
                    $confirmDialog.confirmDialog('close');
                  });
              },
            },
          });
        },
      },
    })
    .on('raceRoster.fileUploader.deleted', (event, $fileUploader) => {
      $fileUploader
        .fileUploader('reset')
        .next()
        .val('');
    })
    .on('raceRoster.fileUploader.invalid', (event, $fileUploader) => {
      $fileUploader.fileUploader('reset');
      data.elements.$snackBar.snackBar('add', {
        type: 'danger',
        icon: 'exclamation-circle',
        content: data.settings.i18n.invalidFileError,
      });
    })
    .on('raceRoster.fileUploader.valid', (event, $fileUploader) => {
      const file = $fileUploader.fileUploader('getFiles')[0];

      $fileUploader.fileUploader('setLoading', true);
      data.settings.registrationPlugin.disableSubmitButtons();

      window.cdbS3Files.uploadFile({
        route: $fileUploader.attr('data-upload-route'),
        data: {
          questionUuid: $fileUploader.attr('data-question-id'),
        },
        file,
      })
        .then((fileUploadUuid) => {
          $fileUploader
            .next()
            .val(fileUploadUuid)
            .trigger('change');
        })
        .catch(() => {
          $fileUploader
            .fileUploader('reset')
            .next()
            .val('')
            .trigger('change');
          data.elements.$snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: data.settings.i18n.uploadFileError,
          });
        })
        .finally(() => {
          data.settings.registrationPlugin.reEnableSubmitButtons();
          $fileUploader
            .fileUploader('setLoading', false)
            .fileUploader('setUploadedState', true);
        });
    })
    .on('click', '[data-js-file-uploader-download]', (event) => {
      const $fileUploader = $(event.delegateTarget);
      const route = `${$fileUploader.attr('data-download-route')}?fileUploadUuid=${$fileUploader.next().val()}`;

      window.cdbS3Files.retrieveFile({
        route,
      })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.style.display = 'none';
          anchor.href = url;
          anchor.target = '_blank';

          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(url);
          anchor.remove();
        })
        .catch(() => {
          data.elements.$snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: data.settings.i18n.downloadFileError,
          });
        })
        .finally(() => {
          $(event.currentTarget).preventDoubleSubmission('reEnable');
        });
    });

  data.elements.$element
    .find('[data-js-file-uploader-download]')
    .preventDoubleSubmission({
      spinnerReplacee: '.fas',
    });
};

/**
 * Show content
 * @param data
 */
const initializeContent = (data) => {
  data.elements.$element.find('.js-parent-question').trigger('change');
  data.elements.$element.find('.question-container[data-alphabetical=1]').each(alphabetizeOptions);
  data.elements.$element
    .find('select')
    .not('.js-teams-join-existing-form-control')
    .each(initializeSelect2);

  // Initialize the phone number fields
  const eventCountryCode = data.settings.eventCountry.toLowerCase();
  data.elements.$element
    .find('[data-format-phone-number]')
    .each((key, element) => window.intlTelInput(element, {
      separateDialCode: true,
      countryOrder: ['us', 'ca', 'gb', 'au'],
      initialCountry: eventCountryCode,
    }));

  // Initialize file uploaders
  setupFileUploaders(data);

  const personalInformation = data.settings.registrantPersonalInformation;

  if (!personalInformation) {
    return;
  }

  toggleGeographicallyLimitedQuestions(
    data,
    personalInformation?.provided_for === 'self' || data.settings.callbacks.getProvidedFor() === 'self',
    personalInformation?.address?.countryCode ?? data.settings.callbacks.getSelectedCountry(),
  );
};

const methods = {
  initializeContent,
  toggleOptInQuestions,
  toggleGeographicallyLimitedQuestions,
};

/**
 * Fire up
 * @param {HTMLElement} element
 * @param {object} options
 */
const initialize = (element, options) => {
  const $element = $(element);

  if ($element.data(pluginName)) {
    return;
  }

  const elements = getElements($element);

  const settings = $.extend(true, {}, $.fn[pluginName].DEFAULTS, options);

  const data = {
    elements,
    settings,
  };

  data.elements.$element.on('change', '.js-parent-question', (event) => {
    const $parent = $(event.currentTarget);

    conditionalQuestionsToggle(data, $parent);
  });

  data.elements.$element.on('change', 'input[pattern]', checkValidPattern);
  data.elements.$element.data(pluginName, data);

  data.elements.$element.on('click', selectors.addCustomOptionButton, showOtherInput);
  data.elements.$element.on('click', selectors.removeCustomOptionButton, removeOtherInput);
  data.elements.$element.on('keyup', selectors.customOptionInput, checkMatchingOptions);
};

/**
 * Call one of our custom plugin methods on each given jQuery object
 */
const callPluginMethod = (element, method, ...methodParameters) => {
  const $element = $(element);
  const data = $element.data(pluginName);

  if (data) {
    methods[method](data, ...methodParameters);
  }

  return $element;
};

/**
 * @param methodOrOptions
 * @param methodParameters
 * @returns {jQuery}
 */
const plugin = function plugin(methodOrOptions, ...methodParameters) {
  if (methods[methodOrOptions]) {
    return this
      .each((index, element) => callPluginMethod(element, methodOrOptions, ...methodParameters));
  }

  if (typeof methodOrOptions === 'object' || !methodOrOptions) {
    return this.each((index, element) => initialize(element, methodOrOptions));
  }

  return $.error(`Method ${methodOrOptions} does not exist in ${pluginName}`);
};

plugin.DEFAULTS = defaults;

$(() => {
  if (pluginName in $.fn) {
    return;
  }

  $.extend($.fn, {
    [pluginName]: plugin,
  });
});
